import React from 'react'
import DataBase from '../common/DataBase';
const MDatabase = () => {
  // const [selected, setSelected] = useState('staff');
  return (
    <div>
    <DataBase />
    </div>
  )
}

export default MDatabase